/**
 * Auto-hiding header on mobile: the sticky header slides away while the
 * reader scrolls down and comes back on any scroll up.
 *
 * Toggles `data-pv-hidden` on `#header-component`; the slide itself and its
 * mobile-only breakpoint live in `pokervault-header-autohide.css`. Runs only
 * for Horizon's `always` sticky mode — `scroll-up` already hides on its own.
 */
(() => {
  const header = document.getElementById('header-component');
  const main = document.getElementById('MainContent');
  if (!header || !main || header.getAttribute('sticky') !== 'always') return;

  const mobile = window.matchMedia('(max-width: 749px)');

  // Travel in one direction before the header reacts, so a finger resting on
  // the screen does not flicker it.
  const TOLERANCE_PX = 8;

  // Scroll position where the current direction of travel began.
  let anchorY = window.scrollY;
  let rafId = null;

  const setHidden = (hidden) => header.toggleAttribute('data-pv-hidden', hidden);

  const update = () => {
    rafId = null;
    if (!mobile.matches) return;

    const y = window.scrollY;
    const maxY = document.documentElement.scrollHeight - window.innerHeight;

    // iOS rubber-band overscroll reports positions past either end; the bounce
    // back would otherwise read as a scroll up.
    if (y < 0 || y > maxY) return;

    // Sticky keeps the header's slot in flow above `main`. While any of that
    // slot is on screen, sliding the header off would uncover an empty strip.
    if (main.getBoundingClientRect().top > 0) {
      setHidden(false);
      anchorY = y;
      return;
    }

    const travel = y - anchorY;
    if (Math.abs(travel) < TOLERANCE_PX) return;

    setHidden(travel > 0);
    anchorY = y;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (rafId === null) rafId = requestAnimationFrame(update);
    },
    { passive: true }
  );

  mobile.addEventListener('change', () => {
    setHidden(false);
    anchorY = window.scrollY;
  });
})();
